<template>
  <div class="flex justify-center items-center" style="height: 82vh">
    <div class="flex items-center column" style="margin-top: -80px">
      <img src="@/assets/images/403.png" width="width" />
      <h5 class="q-my-lg text-bold">You haven't got access to this page</h5>
      <p class="text-center">If you require access please contact your account administrator</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Forbidden',
};
</script>
